export default __webpack_public_path__ + "static/media/untitled1.eb0f47ef.jpeg";